import { useEffect, useRef, useState } from 'react';

import { CountdownTimer } from 'utils/time';
import { useGlobalFunction } from './useGlobalFunction';

interface Props {
  time: number;
}

const useMaintenanceCountdown = ({ time }: Props) => {
  const [isTimeout, setIsTimeout] = useState(time <= 0);
  const countdownRef = useRef<CountdownTimer | null>(null);
  const { onSetDisplayMaintenanceReminder } = useGlobalFunction();

  useEffect(() => {
    setIsTimeout(time <= 0);
  }, [time]);

  useEffect(() => {
    countdownRef.current = new CountdownTimer(time);
    const listener = () => {
      setIsTimeout(true);
    };
    countdownRef.current.addListener(listener);
    countdownRef.current.start(1000);

    return () => {
      if (countdownRef.current) countdownRef.current.removeListener(listener);
    };
  }, [time, onSetDisplayMaintenanceReminder]);

  useEffect(() => {
    return () => {
      if (countdownRef.current) countdownRef.current.stop();
    };
  }, []);

  return {
    isTimeout,
    countdownRef,
  };
};

export default useMaintenanceCountdown;
